
// google autocomplete dropdown
import _ from 'lodash-es';
import validator from '../../validator';
import analytics from '../../analytics';
import inputField from '../../addressForm/input-field';
import util from './../../util';

function loadGoogleAutocompleteData(element) {
	const $element = element; // element param accepts jquery input selector e.g. $(this)
	const $elementClosest = $element.parents('.select-billing-address').length ? $element.closest('.select-billing-address') : $element.closest('form');
	const $country = $element.length && $elementClosest.find('.input-text.country + input[name$="_country"], .input-select.country');

	// generate autocomplete dropdown 
	const $autoCompleteDropdown = $element.length ? $element.closest('.field-wrapper').find(".autocomplete-input-dropdown") : 0;
	if ($autoCompleteDropdown.length === 0 && $element.length) {
		$('<div class="autocomplete-input-dropdown google-autocomplete hide"><ul class="autocomplete-list"></ul></div>').appendTo($element.closest('.field-wrapper'));
		$element.closest('.form-row').addClass('enabled-autocomplete');
	}
	// populate autocomplete data when more than 4 char entered
	if($autoCompleteDropdown.length && ($element.length && $element.val().length > 4) && ($country.length && $country.val() !== null)){
		$.ajax({
			type: 'GET',
			url: Urls.googleAddressAPI,
			data: {
				'action': 1,
				'input': $element.val(),
				'components':'country:' + $country.val()
			},
			success: function (response) {
				var result = response.result;
				if(response.status === '200' && result.length){
					$autoCompleteDropdown.removeClass("hide").find(".autocomplete-list").empty();					
					if(result.length && $element.val().length > 4) {
						$.each(result, function(index, item){
							$('<li class="autocomplete-list-item" data-place-id="'+ item.place_id +'">'+ '<i class="icon-location"></i><span class="list-item-text">'+ item.description +'</span></li>').appendTo($element.closest('.field-wrapper').find(".autocomplete-list"));
						});
					} else {
						$autoCompleteDropdown.addClass('hide').find(".autocomplete-list").empty();	
					}
				}	
			},
			error: function () {
				console.error('something went wrong while fetching data!');
			}
		})	
	} else {
		$autoCompleteDropdown.addClass('hide').find(".autocomplete-list").empty();	
	}
}

// select option from google autocompleted dropdown 
function selectGoogleAutocompleteOption(){
	$(document).off('click', '.google-autocomplete .autocomplete-list-item');// to stop event bubbling	
	$(document).on('click', '.google-autocomplete .autocomplete-list-item', function(e) {
		e.preventDefault();
        var _that = $(this);
		if(_that.data('place-id').length) {
			$.ajax({
				type: 'GET',
				url: Urls.googleAddressAPI,
				data: {
					'action': 2,
					'place_id': _that.data('place-id')
				},
				success: function (response) {
                    const result = response.result;
					const $form = _that.closest('fieldset');
					const $addressField1 = $form.find('input[name$="_address1"]');
					const $addressField2 = $form.find('input[name$="_address2"]');
					const $cityField = $form.find('input[name$="_city"]');
					const $postalField = $form.find('input[name$="_postal"]');

					if (response.status === '200' && Object.keys(result).length !== 0) {
						// assign value to input fields
						(Boolean(result.addressOne)) ? $addressField1.val(result.addressOne) : $addressField1.val('');
                        (Boolean(result.addressTwo)) ? $addressField2.val(result.addressTwo) : $addressField2.val('');
                        (Boolean(result.city)) ? $cityField.val(result.city) : $cityField.val('');
                        (Boolean(result.postal_code)) ? $postalField.val(result.postal_code) : $postalField.val('');

						// to hide dropdown
						_that.closest('.google-autocomplete').addClass('hide');

						if ($addressField1.val().length > 0) {
							$addressField1.parents('.form-row').find('.error-placement').remove();
						}

						if ($cityField.val().length > 0) {
							$cityField.parents('.form-row').find('.error-placement').remove();
						}

						if ($postalField.val().length > 0) {
							$postalField.parents('.form-row').find('.error-placement').remove();
						}

						// to validate field's data
						$addressField1.trigger('blur');
						$cityField.trigger('blur');
						$postalField.trigger('blur');
						
						// google analytics
						analytics.googleAddressTracking();
						inputField.setEditMaterialFields('#EditAddressForm .material-input .input-text, .form-edit-profile .material-input .input-text, .edit-add-address .material-input .input-text, .edit-add-address .material-input .input-textarea, .checkout-shipping .material-input .input-text');
						util.limitCharacters();
					}
				},
				error: function () {
					console.error('something went wrong while fetching data!');
				}
			})
		}	
	});
}

// to init DOM events
function initEvents() {
    // to bind google address autocomplete on keyevents
	$('form[id$="_shippingAddress"], form[id$="EditAddressForm"], .billing-address-section').on('keyup', 'input[name$="_address1"]', function() {
		if (!$(this).is(":-webkit-autofill")) {
			loadGoogleAutocompleteData($(this));
		}
	});

    // to bind click event on google autocomplete dropdown
    selectGoogleAutocompleteOption();

    // close google autocomplete dropdown on outside click
    $(document).on('mouseup', '.pt_checkout, .pt_account, .reveal, .modal-overlay', (e) => {
        const container = $(".autocomplete-input-dropdown.google-autocomplete");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.addClass('hide');
        }
    });
}

export default {
	init : function () {
    	initEvents();
	}	
}